// extracted by mini-css-extract-plugin
module.exports = {"alert":"__alert___1KNLp"};